import commit from '../gas/commit'

commit()
